// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"34654305","283":"37e627a5","346":"ede1632f","496":"307c822d","542":"22ca5b11","666":"9b7d0d95","688":"fe361f6e","719":"2ad6e5ae","841":"b6cbf613"}[chunkId] + ".chunk.js";
};